import { ThunkAction } from 'redux-thunk';
import IStoreState from 'store/IStoreState';
import { actionTriggers } from 'modules/hiring/stateManagement/actionsCreator';
import { axiosRequisitionTile } from 'modules/hiring/stateManagement/api';
import {
  ISetSelectedOpenRequisition,
  TMyOpenRolesActions,
} from 'modules/hiring/stateManagement/actions';
import { TSelectedOpenRequisitionState } from 'modules/hiring/stateManagement/state';

export const getMyOpenRolesData =
  (): ThunkAction<void, IStoreState, null, TMyOpenRolesActions> =>
  async (dispatch, getState) => {
    if (getState().myOpenRoles.isFetching) {
      return;
    }
    dispatch(actionTriggers.getMyOpenRolesStarted());
    try {
      const response = await axiosRequisitionTile();
      dispatch(actionTriggers.getMyOpenRolesSuccess(response));
    } catch (error: any) {
      dispatch(actionTriggers.getMyOpenRolesFailed(error?.message));
    }
  };

export const setSelectedOpenRequisition =
  (
    requisition: TSelectedOpenRequisitionState
  ): ThunkAction<void, IStoreState, null, ISetSelectedOpenRequisition> =>
  (dispatch) => {
    dispatch(actionTriggers.setSelectedOpenRequisition(requisition));
  };
